// extracted by mini-css-extract-plugin
export default {"root":"DownloadMenu_root__PKL6n"};